import { requiredCfm, toM3h, sqftToSqm, fmt, GENERAL_TARGET, WILDFIRE_TARGET, fmtRequiredCfm, fmtRequiredM3h } from '@/lib/calculator';

const SIZES = [100, 150, 200, 300, 400, 500, 750, 1000];

/** Reference targets, computed from the same functions as the calculator (8 ft ceiling). */
export function CadrComparisonTable({ ceilingFt = 8 }: { ceilingFt?: number }) {
  return (
    <div className="max-w-3xl mx-auto">
      <h2 className="text-2xl font-bold text-foreground mb-2">Clean-air targets by room size</h2>
      <p className="text-sm text-muted-foreground mb-4">
        {ceilingFt} ft ceiling. General = {GENERAL_TARGET.each} eACH; wildfire smoke = {WILDFIRE_TARGET.each} eACH (smoke CADR). Taller ceilings need proportionally more.
      </p>
      <div className="overflow-x-auto rounded-lg border border-border">
        <table className="w-full text-sm">
          <thead className="bg-muted">
            <tr>
              <th scope="col" className="text-left p-3">Room</th>
              <th scope="col" className="text-left p-3">General particles</th>
              <th scope="col" className="text-left p-3">Wildfire smoke</th>
            </tr>
          </thead>
          <tbody>
            {SIZES.map((a) => {
              const r = { areaSqFt: a, ceilingFt };
              const g = requiredCfm(r, GENERAL_TARGET.each);
              const w = requiredCfm(r, WILDFIRE_TARGET.each);
              return (
                <tr key={a} className="border-t border-border">
                  <td className="p-3">{a} ft² ({fmt(sqftToSqm(a), 1)} m²)</td>
                  <td className="p-3">{fmtRequiredCfm(g)} <span className="text-muted-foreground">/ {fmtRequiredM3h(toM3h(g))}</span></td>
                  <td className="p-3">{fmtRequiredCfm(w)} <span className="text-muted-foreground">/ {fmtRequiredM3h(toM3h(w))}</span></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
